// import React, { useContext, useEffect, useState } from "react";
// import { FaEnvelope, FaPlusCircle, FaTrash } from "react-icons/fa";
// import axios from "axios";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";

// export default function EventCalendar() {
//   const { user } = useContext(AuthContext);
//   const [events, setEvents] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [showModal, setShowModal] = useState(false);
//   const [deleteConfirm, setDeleteConfirm] = useState({
//     show: false,
//     eventId: null,
//   });
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     date: "",
//     ignoreYear: false,
//     public: false,
//     time: "",
//     createdById: "",
//     createdByName: "",
//     companyId: "",
//     emails: [],
//   });
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [emails, setEmails] = useState([""]);
//   const [selectedEventIdForEmail, setSelectedEventIdForEmail] = useState(null);
//   const [selectedEventForEmail, setSelectedEventForEmail] = useState(null);
//   const [emailErrors, setEmailErrors] = useState([]);

//   const token = localStorage.getItem("token");
//   const headers = { Authorization: `Bearer ${token}` };

//   const fetchEvents = async () => {
//     if (!token || !user) return;
//     try {
//       const res =
//         user.accountType === "COMPANY"
//           ? await axios.get(`${API_URL}/api/events/company/${user.id}`, {
//               headers,
//             })
//           : await axios.get(`${API_URL}/api/events/company/${user.companyId}/createdBy/${user.id}`, {
//               headers,
//             });
//       setEvents(res.data.events || []);
//     } catch (err) {
//       console.error("Error fetching events:", err);
//     }
//   };

//   useEffect(() => {
//     if (!user) return;

//     setFormData((prev) => ({
//       ...prev,
//       createdById: user?.id,
//       createdByName: user?.name,
//       companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//     }));

//     fetchEvents();
//   }, [user]);

//   const handleSubmit = async (e) => {
//   e.preventDefault();
//   if (!token || !user) return;

//   // Validate emails if any exist
//   if (formData.emails && formData.emails.length > 0) {
//     const invalidEmails = formData.emails.filter(
//       email => email.trim() !== "" && !validateEmail(email)
//     );
//     if (invalidEmails.length > 0) {
//       toast.error("Please fix all email validation errors");
//       return;
//     }
//   }

//   const eventData = {
//     ...formData,
//     createdById: user?.id,
//     createdByName: user?.name,
//     companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//     emails: formData.emails?.filter((email) => email.trim() !== "") || [],
//   };

//   try {
//     if (isEditMode) {
//       await axios.put(
//         `${API_URL}/api/events/${formData.eventId}`,
//         eventData,
//         { headers }
//       );
//     } else {
//       await axios.post(`${API_URL}/api/events`, eventData, { headers });
//     }
//     setShowModal(false);
//     setIsEditMode(false);
//     fetchEvents();
//   } catch (err) {
//     toast.error("Failed to save event");
//     console.error(err);
//   }
// };

//   const confirmDelete = async () => {
//     if (!token || !deleteConfirm.eventId) return;
//     try {
//       await axios.delete(`${API_URL}/api/events/${deleteConfirm.eventId}`, {
//         headers,
//       });
//       setDeleteConfirm({ show: false, eventId: null });
//       fetchEvents(); // ✅ Refresh after delete
//     } catch (err) {
//       toast.error("Failed to delete event");
//       console.error(err);
//     }
//   };

//   const handleEditClick = (event) => {
//     setIsEditMode(true);
//     setFormData({
//       ...event,
//       eventId: event.eventId,
//     });
//     setShowModal(true);
//   };

//   const filteredEvents = events.filter((event) => {
//     if (!event.date) return false;
//     return new Date(event.date).toDateString() === selectedDate.toDateString();
//   });

//   const highlightDates = events
//     .filter((e) => e.date)
//     .map((e) => new Date(e.date).toDateString());

//   const getCurrentDate = () => {
//     const now = new Date();
//     return now.toISOString().slice(0, 10);
//   };

//   const getCurrentTime = () => {
//     const now = new Date();
//     return now.toTimeString().slice(0, 5);
//   };

//   const sendEmail = async () => {
//   // Validate all emails before saving
//   const validationErrors = emails.map(email => {
//     if (email && !validateEmail(email)) {
//       return "Please enter a valid email address";
//     }
//     return "";
//   });
  
//   setEmailErrors(validationErrors);

//   // Check if there are any invalid emails
//   const hasErrors = validationErrors.some(error => error !== "");
//   if (hasErrors) {
//     toast.error("Please fix all email validation errors");
//     return;
//   }

//   const token = localStorage.getItem("token");
//   if (!token || !selectedEventIdForEmail) return;

//   const headers = { Authorization: `Bearer ${token}` };

//   try {
//     // Filter out empty emails
//     const validEmails = emails.filter(email => email.trim() !== "");
    
//     // Update the event with the new emails
//     await axios.put(
//       `${API_URL}/api/events/${selectedEventIdForEmail}`,
//       { emails: validEmails },
//       { headers }
//     );
    
//     toast.success("Emails updated successfully");
//     setShowEmailModal(false);
//     setSelectedEventIdForEmail(null);
//     setSelectedEventForEmail(null);
//     setEmails([""]);
//     setEmailErrors([]);
//     fetchEvents();
//   } catch (error) {
//     console.error("Error updating emails:", error);
//     toast.error("Failed to update emails.");
//   }
// };

//   const ToggleSwitch = ({ isOn, handleToggle, label }) => {
//     return (
//       <div className="flex items-center justify-between">
//         <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
//           {label}
//         </span>
//         <button
//           type="button"
//           className={`${
//             isOn ? "bg-blue-600" : "bg-gray-300"
//           } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
//           onClick={handleToggle}
//         >
//           <span
//             className={`${
//               isOn ? "translate-x-6" : "translate-x-1"
//             } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
//           />
//         </button>
//       </div>
//     );
//   };

//   const validateEmail = (email) => {
//   const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return re.test(String(email).toLowerCase());
// };

//   const handleEmailChange = (e, index) => {
//   const newEmails = [...emails];
//   newEmails[index] = e.target.value;
//   setEmails(newEmails);

//   // Validate the email
//   const newErrors = [...emailErrors];
//   if (e.target.value && !validateEmail(e.target.value)) {
//     newErrors[index] = "Please enter a valid email address";
//   } else {
//     newErrors[index] = "";
//   }
//   setEmailErrors(newErrors);
// };


//   return (
//     <div className="w-full min-h-screen bg-gray-100 p-4 md:p-8 dark:bg-gray-900 dark:text-white shadow-lg">
//       <div className="max-w-7xl mx-auto space-y-6">
//         <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//           <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
//             📅 Event Calendar
//           </h1>
//           <button
//             onClick={() => {
//               setShowModal(true);
//               setFormData({
//                 title: "",
//                 description: "",
//                 date: getCurrentDate(),
//                 time: getCurrentTime(),
//                 ignoreYear: false,
//                 public: false,
//                 createdById: user?.id,
//                 createdByName: user?.name,
//                 companyId:
//                   user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//               });
//             }}
//             className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full shadow-md transition-transform transform hover:scale-105"
//           >
//             <FaPlusCircle /> Add Event
//           </button>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 px-4 sm:px-6 md:px-8 lg:px-10">
//           {/* Calendar Section */}
//           <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 text-center dark:text-white">
//               Pick a Date
//             </h2>
//             <div className="flex justify-center">
//               <Calendar
//                 onChange={setSelectedDate}
//                 value={selectedDate}
//                 className="calendar-custom dark:bg-gray-900 dark:text-white"
//                 tileClassName={({ date, view }) => {
//                   if (
//                     view === "month" &&
//                     highlightDates.includes(date.toDateString())
//                   ) {
//                     return "highlighted-date";
//                   }
//                   return "";
//                 }}
//               />
//             </div>
//           </div>

//           {/* Events Section */}
//           <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 dark:text-white">
//               Events on{" "}
//               <span className="text-blue-700 dark:text-blue-400">
//                 {selectedDate.toDateString()}
//               </span>
//             </h2>

//             {filteredEvents.length > 0 ? (
//               <ul className="space-y-4 max-h-[500px] overflow-y-auto custom-scrollbar pr-2">
//                 {filteredEvents.map((event, index) => (
//                   <li
//                     key={event.eventId || index}
//                     className="p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border border-gray-200 dark:bg-gray-900 dark:text-white"
//                   >
//                     <div className="flex-1 dark:bg-gray-900 dark:text-white">
//                       <h3 className="text-lg font-bold text-indigo-700">
//                         {event.title || "Untitled Event"}
//                       </h3>
//                       <p className="text-gray-600 mt-1 dark:text-white">
//                         {event.description || <i>No description</i>}
//                       </p>
//                       {event.date && event.time && (
//                         <p className="text-sm text-blue-600 mt-1">
//                           ⏰{" "}
//                           {new Date(
//                             `${event.date}T${event.time}`
//                           ).toLocaleString()}
//                         </p>
//                       )}
//                       <p className="text-sm text-gray-500 italic mt-1 dark:text-white">
//                         👤 {event.createdByName || "Unknown"}
//                       </p>
//                       <p className="text-sm text-gray-500 mt-1">
//                         {event.public ? (
//                           <span className="text-green-600">Public Event</span>
//                         ) : (
//                           <span className="text-blue-600">Private Event</span>
//                         )}
//                       </p>
//                       {event.createdAt && (
//                         <p className="text-xs text-gray-500 mt-1 dark:text-white">
//                           🕒 Created:{" "}
//                           {new Date(event.createdAt).toLocaleString()}
//                         </p>
//                       )}
//                       {event.emails && event.emails.length > 0 && (
//                         <div className="mt-2 text-sm text-gray-700 dark:text-white">
//                           <p className="font-semibold text-indigo-600">
//                             📧 Emails:
//                           </p>
//                           <ul className="list-disc list-inside ml-2">
//                             {event.emails.map((email, i) => (
//                               <li key={i}>{email}</li>
//                             ))}
//                           </ul>
//                         </div>
//                       )}
//                     </div>

//                     <div className="flex flex-row sm:flex-col gap-2 items-center justify-center">
//                       <button
//                         onClick={() =>
//                           setDeleteConfirm({
//                             show: true,
//                             eventId: event.eventId,
//                           })
//                         }
//                         className="text-red-500 hover:text-red-700 transition"
//                         title="Delete"
//                       >
//                         <FaTrash />
//                       </button>
//                       <button
//                         onClick={() => handleEditClick(event)}
//                         className="text-blue-500 hover:text-blue-700 transition"
//                         title="Edit"
//                       >
//                         ✏️
//                       </button>
//                       <button
//   onClick={() => {
//     setSelectedEventIdForEmail(event.eventId);
//     setSelectedEventForEmail(event); // Store the entire event
//     setEmails(event.emails?.length > 0 ? [...event.emails] : [""]);
//     setShowEmailModal(true);
//   }}
//   className="text-green-600 hover:text-green-800 transition"
//   title="Manage Emails"
// >
//   <FaEnvelope />
// </button>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p className="text-gray-600 italic">No events for this date.</p>
//             )}
//           </div>
//         </div>
//       </div>

//       {showModal && (
//   <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm bg-black/30">
//     <div className="bg-white w-full max-w-md mx-auto rounded-xl shadow-lg p-4 sm:p-6 relative dark:bg-gray-900 dark:text-white">
//       <button
//         onClick={() => setShowModal(false)}
//         className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 hover:text-red-600 text-xl"
//       >
//         ✕
//       </button>
//       <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4 dark:text-white">
//         {isEditMode ? "Edit Event" : "Create a New Event"}
//       </h2>
//       <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
//         <div>
//           <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//             Title
//           </label>
//           <input
//             type="text"
//             required
//             value={formData.title}
//             onChange={(e) =>
//               setFormData({ ...formData, title: e.target.value })
//             }
//             className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
//             placeholder="Event title"
//           />
//         </div>
//         <div>
//           <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//             Description
//           </label>
//           <textarea
//             value={formData.description}
//             onChange={(e) =>
//               setFormData({ ...formData, description: e.target.value })
//             }
//             className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[80px] sm:min-h-[100px] dark:bg-gray-700"
//             placeholder="Event description"
//           ></textarea>
//         </div>
        
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
//           <div>
//             <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//               Date
//             </label>
//             <input
//               type="date"
//               required
//               value={formData.date}
//               onChange={(e) =>
//                 setFormData({ ...formData, date: e.target.value })
//               }
//               className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//               Time
//             </label>
//             <input
//               type="time"
//               required
//               value={formData.time}
//               onChange={(e) =>
//                 setFormData({ ...formData, time: e.target.value })
//               }
//               className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
//             />
//           </div>
//         </div>
        
//         {new Date(formData.date) < new Date() && (
//           <div className="p-2 sm:p-3 bg-gray-50 rounded-lg dark:bg-gray-800">
//             <ToggleSwitch
//               isOn={formData.ignoreYear}
//               handleToggle={() =>
//                 setFormData({
//                   ...formData,
//                   ignoreYear: !formData.ignoreYear,
//                 })
//               }
//               label="Is this a recurring annual event?"
//             />
//           </div>
//         )}
        
//         <div className="p-2 sm:p-3 bg-gray-50 rounded-lg dark:bg-gray-800">
//           <ToggleSwitch
//             isOn={formData.public}
//             handleToggle={() =>
//               setFormData({
//                 ...formData,
//                 public: !formData.public,
//               })
//             }
//             label="Make this event public?"
//           />
//         </div>

//         <button
//           type="submit"
//           className="w-full bg-blue-600 text-white py-2 text-sm sm:text-base rounded-md hover:bg-blue-700 transition"
//         >
//           Save Event
//         </button>
//       </form>
//     </div>
//   </div>
// )}

//       {deleteConfirm.show && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30 ">
//           <div className="bg-white w-full max-w-sm rounded-xl shadow-lg p-6 text-center relative dark:bg-gray-900 dark:text-white">
//             <h2 className="text-lg font-semibold text-gray-800 mb-4">
//               Delete Confirmation
//             </h2>
//             <p className="text-gray-600 mb-6">
//               Are you sure you want to delete this event?
//             </p>
//             <div className="flex justify-center gap-4">
//               <button
//                 onClick={() => setDeleteConfirm({ show: false, eventId: null })}
//                 className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-gray-800"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmDelete}
//                 className="px-4 py-2 rounded bg-red-600 hover:bg-red-700 text-white"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showEmailModal && (
//   <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
//     <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6 relative dark:bg-gray-800 dark:text-white">
//       <button
//         onClick={() => {
//           setShowEmailModal(false);
//           setSelectedEventIdForEmail(null);
//           setSelectedEventForEmail(null);
//           setEmails([""]);
//           setEmailErrors([]);
//         }}
//         className="absolute top-3 right-4 text-gray-600 hover:text-red-600 text-xl dark:text-gray-300"
//       >
//         ✕
//       </button>
//       <h2 className="text-xl font-bold mb-4 dark:text-white">
//         {selectedEventForEmail?.title ? `Emails for: ${selectedEventForEmail.title}` : 'Manage Emails'}
//       </h2>
      
//       <div className="space-y-3 mb-4">
//         {emails.map((email, index) => (
//           <div key={index} className="space-y-1">
//             <div className="flex items-center gap-2">
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => handleEmailChange(e, index)}
//                 className={`flex-1 p-2 border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
//                   emailErrors[index] ? "border-red-500" : ""
//                 }`}
//                 placeholder="Enter email"
//               />
//               {emails.length > 1 && (
//                 <button
//                   type="button"
//                   onClick={() => {
//                     const newEmails = [...emails];
//                     newEmails.splice(index, 1);
//                     setEmails(newEmails);
                    
//                     const newErrors = [...emailErrors];
//                     newErrors.splice(index, 1);
//                     setEmailErrors(newErrors);
//                   }}
//                   className="text-red-500 hover:text-red-700 p-2 dark:text-red-400"
//                   title="Remove email"
//                 >
//                   <FaTrash />
//                 </button>
//               )}
//             </div>
//             {emailErrors[index] && (
//               <p className="text-red-500 text-xs">{emailErrors[index]}</p>
//             )}
//           </div>
//         ))}
//       </div>

//       <div className="flex flex-wrap gap-3 mb-6">
//         <button
//           type="button"
//           onClick={() => {
//             setEmails([...emails, ""]);
//             setEmailErrors([...emailErrors, ""]);
//           }}
//           className="flex items-center gap-1 px-3 py-1.5 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 dark:bg-blue-900/50 dark:text-blue-300 dark:hover:bg-blue-800/50"
//         >
//           <FaPlusCircle /> Add Email
//         </button>
//       </div>

//       <div className="flex justify-end gap-3">
//         <button
//           type="button"
//           onClick={() => {
//             setShowEmailModal(false);
//             setSelectedEventIdForEmail(null);
//             setSelectedEventForEmail(null);
//             setEmails([""]);
//             setEmailErrors([]);
//           }}
//           className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500"
//         >
//           Cancel
//         </button>
//         <button
//           onClick={sendEmail}
//           className="px-4 py-2 rounded bg-green-600 text-white hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-800"
//         >
//           Save Emails
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//       {/* Custom Styles */}
//       <style jsx="true">{`
//   .react-calendar {
//     width: 100%;
//     max-width: 500px;
//     background-color: white;
//     border: none;
//     border-radius: 1rem;
//     padding: 1rem;
//     font-family: inherit;
//   }
//   .dark .react-calendar {
//     background-color: #1f2937;
//     color: white;
//   }
//   .react-calendar__navigation {
//     margin-bottom: 1rem;
//   }
//   .react-calendar__tile {
//     padding: 1rem 0.5rem;
//   }
//   .react-calendar__tile--active {
//     background: #6366f1 !important;
//     color: white !important;
//     border-radius: 9999px !important;
//     font-weight: bold;
//   }
//   .dark .react-calendar__tile:enabled:hover,
//   .dark .react-calendar__tile:enabled:focus {
//     background-color: #374151;
//   }
//   .highlighted-date {
//     background-color: #c7d2fe !important;
//     color: #1e3a8a !important;
//     border-radius: 9999px !important;
//     font-weight: 600;
//   }
//   .dark .highlighted-date {
//     background-color: #4338ca !important;
//     color: #e0e7ff !important;
//   }
//   .highlighted-date:hover {
//     background-color: #a5b4fc !important;
//   }
// `}</style>
//     </div>
//   );
// }




// import React, { useContext, useEffect, useState } from "react";
// import { FaEnvelope, FaPlusCircle, FaTrash } from "react-icons/fa";
// import axios from "axios";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";

// export default function EventCalendar() {
//   const { user } = useContext(AuthContext);
//   const [events, setEvents] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [showModal, setShowModal] = useState(false);
//   const [deleteConfirm, setDeleteConfirm] = useState({
//     show: false,
//     eventId: null,
//   });
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     date: "",
//     ignoreYear: false,
//     public: false,
//     time: "",
//     createdById: "",
//     createdByName: "",
//     companyId: "",
//     emails: [],
//   });
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [emails, setEmails] = useState([""]);
//   const [selectedEventIdForEmail, setSelectedEventIdForEmail] = useState(null);
//   const [selectedEventForEmail, setSelectedEventForEmail] = useState(null);
//   const [emailErrors, setEmailErrors] = useState([]);

//   // Unified calendar (Meetings, Tasks, Reminders, Todos, Events) via /api/calendar/*
//   const [activeStartDate, setActiveStartDate] = useState(new Date());
//   const [calendarData, setCalendarData] = useState({
//     events: [],
//     eventsByDate: {},
//     totalEvents: 0,
//   });
//   const [calendarLoading, setCalendarLoading] = useState(false);

//   const token = localStorage.getItem("token");
//   const headers = { Authorization: `Bearer ${token}` };

//   const fetchEvents = async () => {
//     if (!token || !user) return;
//     try {
//       const res =
//         user.accountType === "COMPANY"
//           ? await axios.get(`${API_URL}/api/events/company/${user.id}`, {
//               headers,
//             })
//           : await axios.get(`${API_URL}/api/events/company/${user.companyId}/createdBy/${user.id}`, {
//               headers,
//             });
//       setEvents(res.data.events || []);
//     } catch (err) {
//       console.error("Error fetching events:", err);
//     }
//   };

//   useEffect(() => {
//     if (!user) return;

//     setFormData((prev) => ({
//       ...prev,
//       createdById: user?.id,
//       createdByName: user?.name,
//       companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//     }));

//     fetchEvents();
//   }, [user]);

//   // Fetch the unified calendar (meetings, tasks, reminders, todos, events)
//   // for whichever month is currently visible on the calendar widget.
//   const fetchCalendarMonth = async (date) => {
//     if (!token || !user) return;
//     try {
//       setCalendarLoading(true);
//       const companyId =
//         user.accountType === "COMPANY" ? user.id : user.companyId;
//       const year = date.getFullYear();
//       const month = date.getMonth() + 1;
//       const res = await axios.get(
//         `${API_URL}/api/calendar/month/${companyId}?year=${year}&month=${month}&userId=${user.id}`,
//         { headers }
//       );
//       setCalendarData({
//         events: res.data?.events || [],
//         eventsByDate: res.data?.eventsByDate || {},
//         totalEvents: res.data?.totalEvents || 0,
//       });
//     } catch (err) {
//       console.error("Error fetching calendar data:", err);
//       setCalendarData({ events: [], eventsByDate: {}, totalEvents: 0 });
//     } finally {
//       setCalendarLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!user) return;
//     fetchCalendarMonth(activeStartDate);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [user, activeStartDate]);

//   const selectedDateKey = `${selectedDate.getFullYear()}-${String(
//     selectedDate.getMonth() + 1
//   ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;

//   const activitiesForSelectedDate =
//     calendarData.eventsByDate?.[selectedDateKey] || [];

//   const calendarHighlightDates = Object.keys(
//     calendarData.eventsByDate || {}
//   ).map((d) => new Date(d).toDateString());

//   const handleSubmit = async (e) => {
//   e.preventDefault();
//   if (!token || !user) return;

//   // Validate emails if any exist
//   if (formData.emails && formData.emails.length > 0) {
//     const invalidEmails = formData.emails.filter(
//       email => email.trim() !== "" && !validateEmail(email)
//     );
//     if (invalidEmails.length > 0) {
//       toast.error("Please fix all email validation errors");
//       return;
//     }
//   }

//   const eventData = {
//     ...formData,
//     createdById: user?.id,
//     createdByName: user?.name,
//     companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//     emails: formData.emails?.filter((email) => email.trim() !== "") || [],
//   };

//   try {
//     if (isEditMode) {
//       await axios.put(
//         `${API_URL}/api/events/${formData.eventId}`,
//         eventData,
//         { headers }
//       );
//     } else {
//       await axios.post(`${API_URL}/api/events`, eventData, { headers });
//     }
//     setShowModal(false);
//     setIsEditMode(false);
//     fetchEvents();
//   } catch (err) {
//     toast.error("Failed to save event");
//     console.error(err);
//   }
// };

//   const confirmDelete = async () => {
//     if (!token || !deleteConfirm.eventId) return;
//     try {
//       await axios.delete(`${API_URL}/api/events/${deleteConfirm.eventId}`, {
//         headers,
//       });
//       setDeleteConfirm({ show: false, eventId: null });
//       fetchEvents(); // ✅ Refresh after delete
//     } catch (err) {
//       toast.error("Failed to delete event");
//       console.error(err);
//     }
//   };

//   const handleEditClick = (event) => {
//     setIsEditMode(true);
//     setFormData({
//       ...event,
//       eventId: event.eventId,
//     });
//     setShowModal(true);
//   };

//   const filteredEvents = events.filter((event) => {
//     if (!event.date) return false;
//     return new Date(event.date).toDateString() === selectedDate.toDateString();
//   });

//   const highlightDates = events
//     .filter((e) => e.date)
//     .map((e) => new Date(e.date).toDateString());

//   const getCurrentDate = () => {
//     const now = new Date();
//     return now.toISOString().slice(0, 10);
//   };

//   const getCurrentTime = () => {
//     const now = new Date();
//     return now.toTimeString().slice(0, 5);
//   };

//   const sendEmail = async () => {
//   // Validate all emails before saving
//   const validationErrors = emails.map(email => {
//     if (email && !validateEmail(email)) {
//       return "Please enter a valid email address";
//     }
//     return "";
//   });
  
//   setEmailErrors(validationErrors);

//   // Check if there are any invalid emails
//   const hasErrors = validationErrors.some(error => error !== "");
//   if (hasErrors) {
//     toast.error("Please fix all email validation errors");
//     return;
//   }

//   const token = localStorage.getItem("token");
//   if (!token || !selectedEventIdForEmail) return;

//   const headers = { Authorization: `Bearer ${token}` };

//   try {
//     // Filter out empty emails
//     const validEmails = emails.filter(email => email.trim() !== "");
    
//     // Update the event with the new emails
//     await axios.put(
//       `${API_URL}/api/events/${selectedEventIdForEmail}`,
//       { emails: validEmails },
//       { headers }
//     );
    
//     toast.success("Emails updated successfully");
//     setShowEmailModal(false);
//     setSelectedEventIdForEmail(null);
//     setSelectedEventForEmail(null);
//     setEmails([""]);
//     setEmailErrors([]);
//     fetchEvents();
//   } catch (error) {
//     console.error("Error updating emails:", error);
//     toast.error("Failed to update emails.");
//   }
// };

//   const ToggleSwitch = ({ isOn, handleToggle, label }) => {
//     return (
//       <div className="flex items-center justify-between">
//         <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
//           {label}
//         </span>
//         <button
//           type="button"
//           className={`${
//             isOn ? "bg-blue-600" : "bg-gray-300"
//           } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
//           onClick={handleToggle}
//         >
//           <span
//             className={`${
//               isOn ? "translate-x-6" : "translate-x-1"
//             } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
//           />
//         </button>
//       </div>
//     );
//   };

//   const validateEmail = (email) => {
//   const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return re.test(String(email).toLowerCase());
// };

//   const handleEmailChange = (e, index) => {
//   const newEmails = [...emails];
//   newEmails[index] = e.target.value;
//   setEmails(newEmails);

//   // Validate the email
//   const newErrors = [...emailErrors];
//   if (e.target.value && !validateEmail(e.target.value)) {
//     newErrors[index] = "Please enter a valid email address";
//   } else {
//     newErrors[index] = "";
//   }
//   setEmailErrors(newErrors);
// };


//   return (
//     <div className="w-full min-h-screen bg-gray-100 p-4 md:p-8 dark:bg-gray-900 dark:text-white shadow-lg">
//       <div className="max-w-7xl mx-auto space-y-6">
//         <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//           <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
//             📅 Event Calendar
//           </h1>
//           <button
//             onClick={() => {
//               setShowModal(true);
//               setFormData({
//                 title: "",
//                 description: "",
//                 date: getCurrentDate(),
//                 time: getCurrentTime(),
//                 ignoreYear: false,
//                 public: false,
//                 createdById: user?.id,
//                 createdByName: user?.name,
//                 companyId:
//                   user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//               });
//             }}
//             className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full shadow-md transition-transform transform hover:scale-105"
//           >
//             <FaPlusCircle /> Add Event
//           </button>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 px-4 sm:px-6 md:px-8 lg:px-10">
//           {/* Calendar Section */}
//           <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 text-center dark:text-white">
//               Pick a Date
//             </h2>
//             <div className="flex justify-center">
//               <Calendar
//                 onChange={setSelectedDate}
//                 value={selectedDate}
//                 onActiveStartDateChange={({ activeStartDate: newStart }) =>
//                   setActiveStartDate(newStart)
//                 }
//                 className="calendar-custom dark:bg-gray-900 dark:text-white"
//                 tileClassName={({ date, view }) => {
//                   if (
//                     view === "month" &&
//                     (highlightDates.includes(date.toDateString()) ||
//                       calendarHighlightDates.includes(date.toDateString()))
//                   ) {
//                     return "highlighted-date";
//                   }
//                   return "";
//                 }}
//               />
//             </div>
//           </div>

//           {/* Events Section */}
//           <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 dark:text-white">
//               Events on{" "}
//               <span className="text-blue-700 dark:text-blue-400">
//                 {selectedDate.toDateString()}
//               </span>
//             </h2>

//             {filteredEvents.length > 0 ? (
//               <ul className="space-y-4 max-h-[500px] overflow-y-auto custom-scrollbar pr-2">
//                 {filteredEvents.map((event, index) => (
//                   <li
//                     key={event.eventId || index}
//                     className="p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border border-gray-200 dark:bg-gray-900 dark:text-white"
//                   >
//                     <div className="flex-1 dark:bg-gray-900 dark:text-white">
//                       <h3 className="text-lg font-bold text-indigo-700">
//                         {event.title || "Untitled Event"}
//                       </h3>
//                       <p className="text-gray-600 mt-1 dark:text-white">
//                         {event.description || <i>No description</i>}
//                       </p>
//                       {event.date && event.time && (
//                         <p className="text-sm text-blue-600 mt-1">
//                           ⏰{" "}
//                           {new Date(
//                             `${event.date}T${event.time}`
//                           ).toLocaleString()}
//                         </p>
//                       )}
//                       <p className="text-sm text-gray-500 italic mt-1 dark:text-white">
//                         👤 {event.createdByName || "Unknown"}
//                       </p>
//                       <p className="text-sm text-gray-500 mt-1">
//                         {event.public ? (
//                           <span className="text-green-600">Public Event</span>
//                         ) : (
//                           <span className="text-blue-600">Private Event</span>
//                         )}
//                       </p>
//                       {event.createdAt && (
//                         <p className="text-xs text-gray-500 mt-1 dark:text-white">
//                           🕒 Created:{" "}
//                           {new Date(event.createdAt).toLocaleString()}
//                         </p>
//                       )}
//                       {event.emails && event.emails.length > 0 && (
//                         <div className="mt-2 text-sm text-gray-700 dark:text-white">
//                           <p className="font-semibold text-indigo-600">
//                             📧 Emails:
//                           </p>
//                           <ul className="list-disc list-inside ml-2">
//                             {event.emails.map((email, i) => (
//                               <li key={i}>{email}</li>
//                             ))}
//                           </ul>
//                         </div>
//                       )}
//                     </div>

//                     <div className="flex flex-row sm:flex-col gap-2 items-center justify-center">
//                       <button
//                         onClick={() =>
//                           setDeleteConfirm({
//                             show: true,
//                             eventId: event.eventId,
//                           })
//                         }
//                         className="text-red-500 hover:text-red-700 transition"
//                         title="Delete"
//                       >
//                         <FaTrash />
//                       </button>
//                       <button
//                         onClick={() => handleEditClick(event)}
//                         className="text-blue-500 hover:text-blue-700 transition"
//                         title="Edit"
//                       >
//                         ✏️
//                       </button>
//                       <button
//   onClick={() => {
//     setSelectedEventIdForEmail(event.eventId);
//     setSelectedEventForEmail(event); // Store the entire event
//     setEmails(event.emails?.length > 0 ? [...event.emails] : [""]);
//     setShowEmailModal(true);
//   }}
//   className="text-green-600 hover:text-green-800 transition"
//   title="Manage Emails"
// >
//   <FaEnvelope />
// </button>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p className="text-gray-600 italic">No events for this date.</p>
//             )}
//           </div>
//         </div>

//         {/* Unified Calendar Activities (Meetings, Tasks, Reminders, Todos, Events) */}
//         <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//           <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 dark:text-white">
//             All Activities on{" "}
//             <span className="text-blue-700 dark:text-blue-400">
//               {selectedDate.toDateString()}
//             </span>
//           </h2>

//           {calendarLoading ? (
//             <p className="text-gray-500 italic dark:text-gray-400">
//               Loading activities...
//             </p>
//           ) : activitiesForSelectedDate.length > 0 ? (
//             <ul className="space-y-3 max-h-[400px] overflow-y-auto custom-scrollbar pr-2">
//               {activitiesForSelectedDate.map((item) => (
//                 <li
//                   key={`${item.type}-${item.id}`}
//                   className="p-3 bg-white rounded-lg shadow-sm border border-gray-200 dark:bg-gray-900 dark:text-white flex items-start justify-between gap-3"
//                 >
//                   <div>
//                     <span
//                       className={`inline-block text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full mb-1 ${
//                         item.type === "MEETING"
//                           ? "bg-blue-100 text-blue-700"
//                           : item.type === "TASK"
//                           ? "bg-purple-100 text-purple-700"
//                           : item.type === "REMINDER"
//                           ? "bg-yellow-100 text-yellow-700"
//                           : item.type === "TODO"
//                           ? "bg-green-100 text-green-700"
//                           : "bg-indigo-100 text-indigo-700"
//                       }`}
//                     >
//                       {item.type}
//                     </span>
//                     <p className="font-semibold text-gray-800 dark:text-white">
//                       {item.title}
//                     </p>
//                     {item.description && (
//                       <p className="text-sm text-gray-600 dark:text-gray-300">
//                         {item.description}
//                       </p>
//                     )}
//                     {item.time && (
//                       <p className="text-xs text-blue-600 mt-1">
//                         ⏰ {item.time.slice(0, 5)}
//                       </p>
//                     )}
//                     {item.assignedTo && item.assignedTo.length > 0 && (
//                       <p className="text-xs text-gray-500 italic mt-1 dark:text-gray-400">
//                         👤 {item.assignedTo.map((p) => p.name).join(", ")}
//                       </p>
//                     )}
//                   </div>
//                   {item.priority && (
//                     <span className="text-[10px] font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap">
//                       {item.priority}
//                     </span>
//                   )}
//                 </li>
//               ))}
//             </ul>
//           ) : (
//             <p className="text-gray-600 italic dark:text-gray-400">
//               No activities for this date.
//             </p>
//           )}
//         </div>
//       </div>

//       {showModal && (
//   <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm bg-black/30">
//     <div className="bg-white w-full max-w-md mx-auto rounded-xl shadow-lg p-4 sm:p-6 relative dark:bg-gray-900 dark:text-white">
//       <button
//         onClick={() => setShowModal(false)}
//         className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 hover:text-red-600 text-xl"
//       >
//         ✕
//       </button>
//       <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4 dark:text-white">
//         {isEditMode ? "Edit Event" : "Create a New Event"}
//       </h2>
//       <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
//         <div>
//           <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//             Title
//           </label>
//           <input
//             type="text"
//             required
//             value={formData.title}
//             onChange={(e) =>
//               setFormData({ ...formData, title: e.target.value })
//             }
//             className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
//             placeholder="Event title"
//           />
//         </div>
//         <div>
//           <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//             Description
//           </label>
//           <textarea
//             value={formData.description}
//             onChange={(e) =>
//               setFormData({ ...formData, description: e.target.value })
//             }
//             className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[80px] sm:min-h-[100px] dark:bg-gray-700"
//             placeholder="Event description"
//           ></textarea>
//         </div>
        
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
//           <div>
//             <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//               Date
//             </label>
//             <input
//               type="date"
//               required
//               value={formData.date}
//               onChange={(e) =>
//                 setFormData({ ...formData, date: e.target.value })
//               }
//               className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
//             />
//           </div>
//           <div>
//             <label className="block text-xs sm:text-sm font-semibold mb-1 text-gray-700 dark:text-gray-300">
//               Time
//             </label>
//             <input
//               type="time"
//               required
//               value={formData.time}
//               onChange={(e) =>
//                 setFormData({ ...formData, time: e.target.value })
//               }
//               className="w-full px-3 py-2 sm:px-4 sm:py-2 text-sm sm:text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700"
//             />
//           </div>
//         </div>
        
//         {new Date(formData.date) < new Date() && (
//           <div className="p-2 sm:p-3 bg-gray-50 rounded-lg dark:bg-gray-800">
//             <ToggleSwitch
//               isOn={formData.ignoreYear}
//               handleToggle={() =>
//                 setFormData({
//                   ...formData,
//                   ignoreYear: !formData.ignoreYear,
//                 })
//               }
//               label="Is this a recurring annual event?"
//             />
//           </div>
//         )}
        
//         <div className="p-2 sm:p-3 bg-gray-50 rounded-lg dark:bg-gray-800">
//           <ToggleSwitch
//             isOn={formData.public}
//             handleToggle={() =>
//               setFormData({
//                 ...formData,
//                 public: !formData.public,
//               })
//             }
//             label="Make this event public?"
//           />
//         </div>

//         <button
//           type="submit"
//           className="w-full bg-blue-600 text-white py-2 text-sm sm:text-base rounded-md hover:bg-blue-700 transition"
//         >
//           Save Event
//         </button>
//       </form>
//     </div>
//   </div>
// )}

//       {deleteConfirm.show && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30 ">
//           <div className="bg-white w-full max-w-sm rounded-xl shadow-lg p-6 text-center relative dark:bg-gray-900 dark:text-white">
//             <h2 className="text-lg font-semibold text-gray-800 mb-4">
//               Delete Confirmation
//             </h2>
//             <p className="text-gray-600 mb-6">
//               Are you sure you want to delete this event?
//             </p>
//             <div className="flex justify-center gap-4">
//               <button
//                 onClick={() => setDeleteConfirm({ show: false, eventId: null })}
//                 className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-gray-800"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmDelete}
//                 className="px-4 py-2 rounded bg-red-600 hover:bg-red-700 text-white"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showEmailModal && (
//   <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
//     <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6 relative dark:bg-gray-800 dark:text-white">
//       <button
//         onClick={() => {
//           setShowEmailModal(false);
//           setSelectedEventIdForEmail(null);
//           setSelectedEventForEmail(null);
//           setEmails([""]);
//           setEmailErrors([]);
//         }}
//         className="absolute top-3 right-4 text-gray-600 hover:text-red-600 text-xl dark:text-gray-300"
//       >
//         ✕
//       </button>
//       <h2 className="text-xl font-bold mb-4 dark:text-white">
//         {selectedEventForEmail?.title ? `Emails for: ${selectedEventForEmail.title}` : 'Manage Emails'}
//       </h2>
      
//       <div className="space-y-3 mb-4">
//         {emails.map((email, index) => (
//           <div key={index} className="space-y-1">
//             <div className="flex items-center gap-2">
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => handleEmailChange(e, index)}
//                 className={`flex-1 p-2 border rounded dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
//                   emailErrors[index] ? "border-red-500" : ""
//                 }`}
//                 placeholder="Enter email"
//               />
//               {emails.length > 1 && (
//                 <button
//                   type="button"
//                   onClick={() => {
//                     const newEmails = [...emails];
//                     newEmails.splice(index, 1);
//                     setEmails(newEmails);
                    
//                     const newErrors = [...emailErrors];
//                     newErrors.splice(index, 1);
//                     setEmailErrors(newErrors);
//                   }}
//                   className="text-red-500 hover:text-red-700 p-2 dark:text-red-400"
//                   title="Remove email"
//                 >
//                   <FaTrash />
//                 </button>
//               )}
//             </div>
//             {emailErrors[index] && (
//               <p className="text-red-500 text-xs">{emailErrors[index]}</p>
//             )}
//           </div>
//         ))}
//       </div>

//       <div className="flex flex-wrap gap-3 mb-6">
//         <button
//           type="button"
//           onClick={() => {
//             setEmails([...emails, ""]);
//             setEmailErrors([...emailErrors, ""]);
//           }}
//           className="flex items-center gap-1 px-3 py-1.5 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 dark:bg-blue-900/50 dark:text-blue-300 dark:hover:bg-blue-800/50"
//         >
//           <FaPlusCircle /> Add Email
//         </button>
//       </div>

//       <div className="flex justify-end gap-3">
//         <button
//           type="button"
//           onClick={() => {
//             setShowEmailModal(false);
//             setSelectedEventIdForEmail(null);
//             setSelectedEventForEmail(null);
//             setEmails([""]);
//             setEmailErrors([]);
//           }}
//           className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500"
//         >
//           Cancel
//         </button>
//         <button
//           onClick={sendEmail}
//           className="px-4 py-2 rounded bg-green-600 text-white hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-800"
//         >
//           Save Emails
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//       {/* Custom Styles */}
//       <style jsx="true">{`
//   .react-calendar {
//     width: 100%;
//     max-width: 500px;
//     background-color: white;
//     border: none;
//     border-radius: 1rem;
//     padding: 1rem;
//     font-family: inherit;
//   }
//   .dark .react-calendar {
//     background-color: #1f2937;
//     color: white;
//   }
//   .react-calendar__navigation {
//     margin-bottom: 1rem;
//   }
//   .react-calendar__tile {
//     padding: 1rem 0.5rem;
//   }
//   .react-calendar__tile--active {
//     background: #6366f1 !important;
//     color: white !important;
//     border-radius: 9999px !important;
//     font-weight: bold;
//   }
//   .dark .react-calendar__tile:enabled:hover,
//   .dark .react-calendar__tile:enabled:focus {
//     background-color: #374151;
//   }
//   .highlighted-date {
//     background-color: #c7d2fe !important;
//     color: #1e3a8a !important;
//     border-radius: 9999px !important;
//     font-weight: 600;
//   }
//   .dark .highlighted-date {
//     background-color: #4338ca !important;
//     color: #e0e7ff !important;
//   }
//   .highlighted-date:hover {
//     background-color: #a5b4fc !important;
//   }
// `}</style>
//     </div>
//   );
// }




import React, { useContext, useEffect, useState } from "react";
import { FaEnvelope, FaPlusCircle, FaTrash, FaEdit, FaTimes } from "react-icons/fa";
import axios from "axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";
import { PlusIcon, XMarkIcon } from "@heroicons/react/24/solid";

export default function EventCalendar() {
  const { user } = useContext(AuthContext);
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({
    show: false,
    eventId: null,
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    date: "",
    ignoreYear: false,
    public: false,
    time: "",
    createdById: "",
    createdByName: "",
    companyId: "",
    emails: [],
  });
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emails, setEmails] = useState([""]);
  const [selectedEventIdForEmail, setSelectedEventIdForEmail] = useState(null);
  const [selectedEventForEmail, setSelectedEventForEmail] = useState(null);
  const [emailErrors, setEmailErrors] = useState([]);

  // Unified calendar (Meetings, Tasks, Reminders, Todos, Events) via /api/calendar/*
  const [activeStartDate, setActiveStartDate] = useState(new Date());
  const [calendarData, setCalendarData] = useState({
    events: [],
    eventsByDate: {},
    totalEvents: 0,
  });
  const [calendarLoading, setCalendarLoading] = useState(false);

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const fetchEvents = async () => {
    if (!token || !user) return;
    try {
      const res =
        user.accountType === "COMPANY"
          ? await axios.get(`${API_URL}/api/events/company/${user.id}`, {
              headers,
            })
          : await axios.get(`${API_URL}/api/events/company/${user.companyId}/createdBy/${user.id}`, {
              headers,
            });
      setEvents(res.data.events || []);
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  };

  useEffect(() => {
    if (!user) return;

    setFormData((prev) => ({
      ...prev,
      createdById: user?.id,
      createdByName: user?.name,
      companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
    }));

    fetchEvents();
  }, [user]);

  // Fetch the unified calendar (meetings, tasks, reminders, todos, events)
  // for whichever month is currently visible on the calendar widget.
  const fetchCalendarMonth = async (date) => {
    if (!token || !user) return;
    try {
      setCalendarLoading(true);
      const companyId =
        user.accountType === "COMPANY" ? user.id : user.companyId;
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const res = await axios.get(
        `${API_URL}/api/calendar/month/${companyId}?year=${year}&month=${month}&userId=${user.id}`,
        { headers }
      );
      setCalendarData({
        events: res.data?.events || [],
        eventsByDate: res.data?.eventsByDate || {},
        totalEvents: res.data?.totalEvents || 0,
      });
    } catch (err) {
      console.error("Error fetching calendar data:", err);
      setCalendarData({ events: [], eventsByDate: {}, totalEvents: 0 });
    } finally {
      setCalendarLoading(false);
    }
  };

  useEffect(() => {
    if (!user) return;
    fetchCalendarMonth(activeStartDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, activeStartDate]);

  const selectedDateKey = `${selectedDate.getFullYear()}-${String(
    selectedDate.getMonth() + 1
  ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;

  const activitiesForSelectedDate =
    calendarData.eventsByDate?.[selectedDateKey] || [];

  const calendarHighlightDates = Object.keys(
    calendarData.eventsByDate || {}
  ).map((d) => new Date(d).toDateString());

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token || !user) return;

    // Validate emails if any exist
    if (formData.emails && formData.emails.length > 0) {
      const invalidEmails = formData.emails.filter(
        email => email.trim() !== "" && !validateEmail(email)
      );
      if (invalidEmails.length > 0) {
        toast.error("Please fix all email validation errors");
        return;
      }
    }

    const eventData = {
      ...formData,
      createdById: user?.id,
      createdByName: user?.name,
      companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
      emails: formData.emails?.filter((email) => email.trim() !== "") || [],
    };

    try {
      if (isEditMode) {
        await axios.put(
          `${API_URL}/api/events/${formData.eventId}`,
          eventData,
          { headers }
        );
      } else {
        await axios.post(`${API_URL}/api/events`, eventData, { headers });
      }
      setShowModal(false);
      setIsEditMode(false);
      fetchEvents();
    } catch (err) {
      toast.error("Failed to save event");
      console.error(err);
    }
  };

  const confirmDelete = async () => {
    if (!token || !deleteConfirm.eventId) return;
    try {
      await axios.delete(`${API_URL}/api/events/${deleteConfirm.eventId}`, {
        headers,
      });
      setDeleteConfirm({ show: false, eventId: null });
      fetchEvents(); 
    } catch (err) {
      toast.error("Failed to delete event");
      console.error(err);
    }
  };

  const handleEditClick = (event) => {
    setIsEditMode(true);
    setFormData({
      ...event,
      eventId: event.eventId,
    });
    setShowModal(true);
  };

  const filteredEvents = events.filter((event) => {
    if (!event.date) return false;
    return new Date(event.date).toDateString() === selectedDate.toDateString();
  });

  const highlightDates = events
    .filter((e) => e.date)
    .map((e) => new Date(e.date).toDateString());

  const getCurrentDate = () => {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  };

  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  };

  const sendEmail = async () => {
    // Validate all emails before saving
    const validationErrors = emails.map(email => {
      if (email && !validateEmail(email)) {
        return "Please enter a valid email address";
      }
      return "";
    });
    
    setEmailErrors(validationErrors);

    // Check if there are any invalid emails
    const hasErrors = validationErrors.some(error => error !== "");
    if (hasErrors) {
      toast.error("Please fix all email validation errors");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token || !selectedEventIdForEmail) return;

    const headers = { Authorization: `Bearer ${token}` };

    try {
      // Filter out empty emails
      const validEmails = emails.filter(email => email.trim() !== "");
      
      // Update the event with the new emails
      await axios.put(
        `${API_URL}/api/events/${selectedEventIdForEmail}`,
        { emails: validEmails },
        { headers }
      );
      
      toast.success("Emails updated successfully");
      setShowEmailModal(false);
      setSelectedEventIdForEmail(null);
      setSelectedEventForEmail(null);
      setEmails([""]);
      setEmailErrors([]);
      fetchEvents();
    } catch (error) {
      console.error("Error updating emails:", error);
      toast.error("Failed to update emails.");
    }
  };

  const ToggleSwitch = ({ isOn, handleToggle, label }) => {
    return (
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-[#374151] dark:text-gray-300">
          {label}
        </span>
        <button
          type="button"
          className={`${
            isOn ? "bg-[#673AB7]" : "bg-gray-300 dark:bg-gray-600"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#E9D5FF]`}
          onClick={handleToggle}
        >
          <span
            className={`${
              isOn ? "translate-x-6" : "translate-x-1"
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </button>
      </div>
    );
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e, index) => {
    const newEmails = [...emails];
    newEmails[index] = e.target.value;
    setEmails(newEmails);

    // Validate the email
    const newErrors = [...emailErrors];
    if (e.target.value && !validateEmail(e.target.value)) {
      newErrors[index] = "Please enter a valid email address";
    } else {
      newErrors[index] = "";
    }
    setEmailErrors(newErrors);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); 
        .cfg-heading { font-family: 'Sora', sans-serif; color: #1F2937; } 
        .cfg-font { font-family: 'Inter', sans-serif; }

        .react-calendar {
          width: 100%;
          background-color: transparent !important;
          border: none !important;
          font-family: inherit;
        }
        .dark .react-calendar {
          background-color: transparent !important;
          color: white;
        }
        .react-calendar__navigation {
          margin-bottom: 1rem;
        }
        .react-calendar__tile {
          padding: 1rem 0.5rem;
          border-radius: 0.5rem;
        }
        .react-calendar__tile--active {
          background: #673AB7 !important;
          color: white !important;
          border-radius: 0.5rem !important;
          font-weight: bold;
        }
        .react-calendar__tile:enabled:hover,
        .react-calendar__tile:enabled:focus {
          background-color: #F3E8FF;
          color: #673AB7;
          border-radius: 0.5rem;
        }
        .dark .react-calendar__tile:enabled:hover,
        .dark .react-calendar__tile:enabled:focus {
          background-color: #374151;
          color: white;
        }
        .highlighted-date {
          background-color: #F3E8FF !important;
          color: #673AB7 !important;
          border-radius: 0.5rem !important;
          font-weight: 600;
        }
        .dark .highlighted-date {
          background-color: rgba(103, 58, 183, 0.3) !important;
          color: #E9D5FF !important;
        }
        .highlighted-date:hover {
          background-color: #E9D5FF !important;
        }
      `}</style>
      
      <div className="w-full min-h-screen bg-[#FAF8FF] dark:bg-gray-900 p-4 md:p-6 lg:p-8 cfg-font shadow-lg rounded-lg">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-2">
            <h1 className="text-2xl sm:text-3xl font-bold cfg-heading dark:text-white flex items-center gap-2">
              📅 Event Calendar
            </h1>
            <button
              onClick={() => {
                setShowModal(true);
                setFormData({
                  title: "",
                  description: "",
                  date: getCurrentDate(),
                  time: getCurrentTime(),
                  ignoreYear: false,
                  public: false,
                  createdById: user?.id,
                  createdByName: user?.name,
                  companyId:
                    user?.accountType === "COMPANY" ? user?.id : user?.companyId,
                });
              }}
              className="flex items-center gap-2 bg-[#673AB7] hover:bg-[#5E35A6] text-white px-5 py-2.5 rounded-md shadow-sm transition font-semibold text-sm"
            >
              <PlusIcon className="w-5 h-5" /> Add Event
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Calendar Section */}
            <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
              <h2 className="text-lg sm:text-xl font-bold cfg-heading text-center mb-4 dark:text-white">
                Pick a Date
              </h2>
              <div className="flex justify-center">
                <Calendar
                  onChange={setSelectedDate}
                  value={selectedDate}
                  onActiveStartDateChange={({ activeStartDate: newStart }) =>
                    setActiveStartDate(newStart)
                  }
                  className="calendar-custom dark:text-white"
                  tileClassName={({ date, view }) => {
                    if (
                      view === "month" &&
                      (highlightDates.includes(date.toDateString()) ||
                        calendarHighlightDates.includes(date.toDateString()))
                    ) {
                      return "highlighted-date";
                    }
                    return "";
                  }}
                />
              </div>
            </div>

            {/* Events Section */}
            <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700 flex flex-col h-full">
              <h2 className="text-lg sm:text-xl font-bold cfg-heading mb-4 dark:text-white">
                Events on{" "}
                <span className="text-[#673AB7] dark:text-[#E9D5FF]">
                  {selectedDate.toDateString()}
                </span>
              </h2>

              {filteredEvents.length > 0 ? (
                <ul className="space-y-4 flex-1 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                  {filteredEvents.map((event, index) => (
                    <li
                      key={event.eventId || index}
                      className="p-4 bg-[#FAF8FF] rounded-lg shadow-sm border border-[#E5E7EB] hover:shadow-md transition flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 dark:bg-gray-700 dark:border-gray-600"
                    >
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-[#673AB7] dark:text-[#E9D5FF]">
                          {event.title || "Untitled Event"}
                        </h3>
                        <p className="text-[#374151] text-sm mt-1 dark:text-gray-300">
                          {event.description || <i>No description</i>}
                        </p>
                        {event.date && event.time && (
                          <p className="text-sm font-medium text-[#4B5563] mt-2 dark:text-gray-400">
                            <span className="mr-1">⏰</span>
                            {new Date(`${event.date}T${event.time}`).toLocaleString()}
                          </p>
                        )}
                        <p className="text-xs text-[#6B7280] italic mt-1.5 dark:text-gray-400">
                          👤 Created by {event.createdByName || "Unknown"}
                        </p>
                        <p className="text-xs font-semibold mt-1.5">
                          {event.public ? (
                            <span className="text-[#10B981] bg-[#D1FAE5] dark:bg-emerald-900/30 px-2 py-0.5 rounded">Public Event</span>
                          ) : (
                            <span className="text-[#673AB7] bg-[#F3E8FF] dark:bg-purple-900/30 px-2 py-0.5 rounded">Private Event</span>
                          )}
                        </p>
                        {event.createdAt && (
                          <p className="text-[11px] text-[#9CA3AF] mt-1.5 dark:text-gray-500">
                            Created: {new Date(event.createdAt).toLocaleString()}
                          </p>
                        )}
                        {event.emails && event.emails.length > 0 && (
                          <div className="mt-3 text-sm text-[#374151] dark:text-gray-300 border-t border-[#E5E7EB] dark:border-gray-600 pt-2">
                            <p className="font-semibold text-[#673AB7] dark:text-[#E9D5FF] mb-1">
                              📧 Emails:
                            </p>
                            <ul className="list-disc list-inside ml-1 space-y-0.5 text-xs">
                              {event.emails.map((email, i) => (
                                <li key={i}>{email}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>

                      <div className="flex flex-row sm:flex-col gap-3 items-center justify-center bg-white dark:bg-gray-800 p-2 rounded-md border border-[#E5E7EB] dark:border-gray-600 shadow-sm">
                        <button
                          onClick={() => handleEditClick(event)}
                          className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] transition p-1"
                          title="Edit"
                        >
                          <FaEdit className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedEventIdForEmail(event.eventId);
                            setSelectedEventForEmail(event);
                            setEmails(event.emails?.length > 0 ? [...event.emails] : [""]);
                            setShowEmailModal(true);
                          }}
                          className="text-[#10B981] hover:text-[#059669] transition p-1"
                          title="Manage Emails"
                        >
                          <FaEnvelope className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() =>
                            setDeleteConfirm({
                              show: true,
                              eventId: event.eventId,
                            })
                          }
                          className="text-[#EF4444] hover:text-[#B91C1C] transition p-1"
                          title="Delete"
                        >
                          <FaTrash className="w-4 h-4" />
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="flex-1 flex flex-col items-center justify-center text-center p-6 border-2 border-dashed border-[#E5E7EB] dark:border-gray-600 rounded-lg">
                  <p className="text-[#6B7280] italic dark:text-gray-400">No events scheduled for this date.</p>
                </div>
              )}
            </div>
          </div>

          {/* Unified Calendar Activities Section */}
          <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
            <h2 className="text-lg sm:text-xl font-bold cfg-heading mb-4 dark:text-white border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
              All Activities on{" "}
              <span className="text-[#673AB7] dark:text-[#E9D5FF]">
                {selectedDate.toDateString()}
              </span>
            </h2>

            {calendarLoading ? (
              <p className="text-[#6B7280] italic dark:text-gray-400 text-center py-4">
                Loading activities...
              </p>
            ) : activitiesForSelectedDate.length > 0 ? (
              <ul className="space-y-3 max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600 pr-2">
                {activitiesForSelectedDate.map((item) => (
                  <li
                    key={`${item.type}-${item.id}`}
                    className="p-3 bg-[#FAF8FF] rounded-lg shadow-sm border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 flex items-start justify-between gap-3 hover:shadow-md transition"
                  >
                    <div>
                      <span
                        className={`inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded mb-1.5 border ${
                          item.type === "MEETING"
                            ? "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800"
                            : item.type === "TASK"
                            ? "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-800"
                            : item.type === "REMINDER"
                            ? "bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:border-yellow-800"
                            : item.type === "TODO"
                            ? "bg-green-50 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800"
                            : "bg-[#F3E8FF] text-[#673AB7] border-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-800"
                        }`}
                      >
                        {item.type}
                      </span>
                      <p className="font-bold text-[#1F2937] dark:text-white text-sm">
                        {item.title}
                      </p>
                      {item.description && (
                        <p className="text-xs text-[#374151] mt-1 dark:text-gray-300">
                          {item.description}
                        </p>
                      )}
                      {item.time && (
                        <p className="text-xs font-medium text-[#4B5563] mt-1.5 dark:text-gray-400">
                          <span className="mr-1">⏰</span> {item.time.slice(0, 5)}
                        </p>
                      )}
                      {item.assignedTo && item.assignedTo.length > 0 && (
                        <p className="text-[11px] text-[#6B7280] font-medium mt-1.5 dark:text-gray-400">
                          👤 Assigned: {item.assignedTo.map((p) => p.name).join(", ")}
                        </p>
                      )}
                    </div>
                    {item.priority && (
                      <span className="text-[10px] font-semibold text-[#6B7280] dark:text-gray-400 bg-white dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-600 px-2 py-0.5 rounded">
                        {item.priority}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <div className="flex-1 flex flex-col items-center justify-center text-center p-6 border-2 border-dashed border-[#E5E7EB] dark:border-gray-600 rounded-lg">
                <p className="text-[#6B7280] italic dark:text-gray-400">No activities for this date.</p>
              </div>
            )}
          </div>
        </div>

        {/* Add / Edit Event Modal */}
        {showModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white w-full max-w-lg mx-auto rounded-xl shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700 flex flex-col max-h-[90vh]">
              
              {/* Header */}
              <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
                <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
                  {isEditMode ? "Edit Event" : "Create a New Event"}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>

              {/* Body */}
              <div className="p-5 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-xs sm:text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                      Title <span className="text-[#EF4444]">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.title}
                      onChange={(e) =>
                        setFormData({ ...formData, title: e.target.value })
                      }
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      placeholder="Event title"
                    />
                  </div>

                  <div>
                    <label className="block text-xs sm:text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                      Description
                    </label>
                    <textarea
                      value={formData.description}
                      onChange={(e) =>
                        setFormData({ ...formData, description: e.target.value })
                      }
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[100px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      placeholder="Event description"
                    ></textarea>
                  </div>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                        Date <span className="text-[#EF4444]">*</span>
                      </label>
                      <input
                        type="date"
                        required
                        value={formData.date}
                        onChange={(e) =>
                          setFormData({ ...formData, date: e.target.value })
                        }
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      />
                    </div>
                    <div>
                      <label className="block text-xs sm:text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                        Time <span className="text-[#EF4444]">*</span>
                      </label>
                      <input
                        type="time"
                        required
                        value={formData.time}
                        onChange={(e) =>
                          setFormData({ ...formData, time: e.target.value })
                        }
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-3 mt-2">
                    {new Date(formData.date) < new Date() && (
                      <div className="p-3 bg-[#FAF8FF] border border-[#E5E7EB] rounded-md dark:bg-gray-700 dark:border-gray-600">
                        <ToggleSwitch
                          isOn={formData.ignoreYear}
                          handleToggle={() =>
                            setFormData({
                              ...formData,
                              ignoreYear: !formData.ignoreYear,
                            })
                          }
                          label="Is this a recurring annual event?"
                        />
                      </div>
                    )}
                    
                    <div className="p-3 bg-[#FAF8FF] border border-[#E5E7EB] rounded-md dark:bg-gray-700 dark:border-gray-600">
                      <ToggleSwitch
                        isOn={formData.public}
                        handleToggle={() =>
                          setFormData({
                            ...formData,
                            public: !formData.public,
                          })
                        }
                        label="Make this event public?"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 border-t border-[#E5E7EB] dark:border-gray-700 pt-4 mt-4">
                    <button
                      type="button"
                      onClick={() => setShowModal(false)}
                      className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-5 py-2 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition font-semibold text-sm"
                    >
                      Save Event
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {deleteConfirm.show && (
          <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50 p-4">
            <div className="bg-white dark:bg-gray-800 w-full max-w-sm rounded-xl shadow-2xl border border-[#E5E7EB] dark:border-gray-700 p-6 relative flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-[#FEF2F2] dark:bg-red-900/30 flex items-center justify-center mb-4">
                <FaTrash className="text-[#EF4444] text-xl" />
              </div>
              <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-2">
                Delete Event
              </h2>
              <p className="text-[#6B7280] dark:text-gray-400 text-center mb-6 text-sm">
                Are you sure you want to delete this event? This action cannot be undone.
              </p>
              <div className="flex justify-center gap-3 w-full">
                <button
                  onClick={() => setDeleteConfirm({ show: false, eventId: null })}
                  className="flex-1 px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  className="flex-1 px-4 py-2 bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition font-semibold text-sm"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Manage Emails Modal */}
        {showEmailModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50 p-4">
            <div className="bg-white w-full max-w-md rounded-xl shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700 flex flex-col max-h-[90vh]">
              {/* Header */}
              <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
                <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white truncate pr-4">
                  {selectedEventForEmail?.title ? `Emails for: ${selectedEventForEmail.title}` : 'Manage Emails'}
                </h2>
                <button
                  onClick={() => {
                    setShowEmailModal(false);
                    setSelectedEventIdForEmail(null);
                    setSelectedEventForEmail(null);
                    setEmails([""]);
                    setEmailErrors([]);
                  }}
                  className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>
              
              {/* Body */}
              <div className="p-5 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                <div className="space-y-3 mb-5">
                  {emails.map((email, index) => (
                    <div key={index} className="space-y-1.5">
                      <div className="flex items-center gap-2">
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => handleEmailChange(e, index)}
                          className={`flex-1 p-2.5 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                            emailErrors[index] ? "border-[#EF4444]" : "border-[#E5E7EB]"
                          }`}
                          placeholder="Enter email address"
                        />
                        {emails.length > 1 && (
                          <button
                            type="button"
                            onClick={() => {
                              const newEmails = [...emails];
                              newEmails.splice(index, 1);
                              setEmails(newEmails);
                              
                              const newErrors = [...emailErrors];
                              newErrors.splice(index, 1);
                              setEmailErrors(newErrors);
                            }}
                            className="text-[#EF4444] hover:text-[#B91C1C] p-2.5 bg-[#FEF2F2] hover:bg-red-100 rounded-md dark:bg-red-900/30 dark:hover:bg-red-900/50 transition"
                            title="Remove email"
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                      {emailErrors[index] && (
                        <p className="text-[#EF4444] text-xs font-medium">{emailErrors[index]}</p>
                      )}
                    </div>
                  ))}
                </div>

                <div className="mb-6">
                  <button
                    type="button"
                    onClick={() => {
                      setEmails([...emails, ""]);
                      setEmailErrors([...emailErrors, ""]);
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-[#F3E8FF] text-[#673AB7] font-semibold text-sm rounded-md hover:bg-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300 dark:hover:bg-purple-900/50 transition"
                  >
                    <FaPlusCircle /> Add Email
                  </button>
                </div>

                <div className="flex justify-end gap-3 border-t border-[#E5E7EB] dark:border-gray-700 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      setShowEmailModal(false);
                      setSelectedEventIdForEmail(null);
                      setSelectedEventForEmail(null);
                      setEmails([""]);
                      setEmailErrors([]);
                    }}
                    className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={sendEmail}
                    className="px-5 py-2 bg-[#10B981] text-white rounded-md hover:bg-[#059669] shadow-md transition font-semibold text-sm"
                  >
                    Save Emails
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}